'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    twentyninetimes.siteHeader.init();
    //twentyninetimes.siteFooter.init();
    twentyninetimes.navigation.init();
    twentyninetimes.siteLanguage.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.siteSliders.init();
    twentyninetimes.oembedToggle.init();
    twentyninetimes.accordion.init();
    twentyninetimes.tooltip.init();
    twentyninetimes.blockProductguide.init();
    twentyninetimes.itemProduct.init();
    twentyninetimes.filters.init();
    twentyninetimes.formular.init();
    twentyninetimes.anchorScroll.init();


    // When clicking on an img inside a container, create a new gallery modal containing the img and all it sibling imgs. Create nav buttons to the gallery so you can navigate between the imgs. Set the clicked img as the active one.
    var galleryContainers = document.querySelectorAll('.js-gallery-modal');
    if ( galleryContainers ) {
        galleryContainers.forEach((container) => {
            var imgs = container.querySelectorAll('img');
            var gallery = [];
            var activeIndex = 0;

            imgs.forEach((img, index) => {
                img.addEventListener('click', () => {
                    gallery = [];
                    activeIndex = index;

                    imgs.forEach((img) => {
                        var src = img.parentNode.getAttribute('data-img-src');
                        gallery.push(src);
                    });

                    var galleryModal = document.createElement('div');
                    galleryModal.classList.add('gallery-modal');
                    galleryModal.innerHTML = `
                        <div class="gallery-modal__inner">
                            <div class="gallery-modal__img" style="background-image: url(${gallery[activeIndex]})"></div>
                        </div>
                        <div class="gallery-modal__nav flickity-button previous"></div>
                        <div class="gallery-modal__nav flickity-button next"></div>
                        <div class="gallery-modal__close"></div>
                    `;

                    document.body.appendChild(galleryModal);
                    
                    setTimeout(() => {
                        galleryModal.classList.add('active');
                    }, 0);

                    var closeBtn = galleryModal.querySelector('.gallery-modal__close');
                    closeBtn.addEventListener('click', () => {
                        galleryModal.classList.remove('active');

                        setTimeout(() => {
                          galleryModal.remove();
                        }, 1000);
                    });

                    var prevBtn = galleryModal.querySelector('.gallery-modal__nav.previous');
                    prevBtn.addEventListener('click', () => {
                      previousSlide();
                    });

                    var nextBtn = galleryModal.querySelector('.gallery-modal__nav.next');
                    nextBtn.addEventListener('click', () => {
                      nextSlide();
                    });

                    window.addEventListener('keydown', event => {
                      if (event.key == "ArrowLeft") {
                        previousSlide();
                      } else if (event.key == "ArrowRight") {
                        nextSlide();
                      }
                    })

                    function nextSlide() {
                      activeIndex = activeIndex + 1 >= gallery.length ? 0 : activeIndex + 1;
                      var img = galleryModal.querySelector('.gallery-modal__img');
                      img.style.backgroundImage = `url(${gallery[activeIndex]})`;
                    }

                    function previousSlide() {
                      activeIndex = activeIndex - 1 < 0 ? gallery.length - 1 : activeIndex - 1;
                      var img = galleryModal.querySelector('.gallery-modal__img');
                      img.style.backgroundImage = `url(${gallery[activeIndex]})`;
                    }
                });
            });
        });
    }

    var inViewItems = document.querySelectorAll('.in-view-item');
    if ( inViewItems ) {
        var test = (item) => {
            if ( !item.classList.contains('visible') ) {
                item.classList.add('visible');

                if ( item.classList.contains('autoplay-video') ) {
                  var playBtn = item.querySelector('.js-oembed-toggle.js-oembed-inline');
                  if ( !playBtn ) return;
                  
                  playBtn.click();
                }

                if ( item.classList.contains('lazy-load-map') ) {
                  var script = document.createElement('script');
                  script.type = 'text/javascript';
                  script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCUt6RwK6ZeLQyULIKre5jDlv5xz6mTUyc&loading=async&callback=initMap';    

                  document.head.appendChild(script);
                }

                setTimeout(() => {
                  item.classList.remove('in-view-item');
                }, 600);
            }
        };
        twentyninetimes.inView.init(inViewItems, test, -100);
    }

    // Scroll functions
    window.onscroll = function () {
        // INSERT FUNCTIONS TO TRIGGER ON SCROLL
        twentyninetimes.siteHeader.checkScroll();
    };

    // Resize functions
    window.onresize = function () { 
        // INSERT FUNCTIONS TO TRIGGER ON WINDOW RESIZE
    };
    
});